export function textbox(options = { type: 'single line' }) {
    return {
        name: 'textbox',
        options,
    };
}
export function dropdown(options) {
    return {
        name: 'dropdown',
        options,
    };
}
export function checkbox() {
    return {
        name: 'checkbox',
        options: {},
    };
}
